export interface ChatParameters {
    market: string;
    language: string;
    chatIdString: string;
}

export interface ChatStartParameters extends ChatParameters {
    itemId: string;
    currentUrl: string;
}

export interface ChatMessageParameters extends ChatParameters {
    itemId: string;
    content: string;
    currentUrl: string;
}

export interface ChatUpdateParameters extends ChatParameters {
    latestMessageIdString: string;
    maxMillisecondsTimeOut: number;
}

export interface ChatLastMessageParameters {
    latestMessageIdString: string;
    chatIdString: string;
}
